"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.reorder = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var reorder = function reorder(array, move) {
  if (!move.destination) {
    return array;
  }

  var result = _toConsumableArray(array);

  var element = result.splice(move.source.index, 1)[0];
  result.splice(move.destination.index, 0, element);
  return result;
};

exports.reorder = reorder;

var remove = function remove(array, index) {
  return [].concat(_toConsumableArray(array.slice(0, index)), _toConsumableArray(array.slice(index + 1, array.length)));
};

exports.remove = remove;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/form/drag_and_drop/utils.js
// module id = 742
// module chunks = 0 15 16 17 18